<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{on, attrs}">
      <v-btn v-on="on" v-bind="attrs" :color="color">
        <v-icon>mdi-plus</v-icon>
        {{ text }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar :color="color">
        <v-toolbar-title class="white--text">{{ text }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select label="Source" v-model="saisieSource" :items="sources"></v-select>
      </v-card-text>
      <v-card-actions>
        <v-progress-circular indeterminate :color="color" v-if="creating"></v-progress-circular>
        <v-btn @click="createSaisie" :disabled="creating" :color="color">
          Ajouter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {TYPES_DECAISSEMENT, TYPES_DECAISSEMENT_HORS_PLAN, TYPES_ENCAISSEMENT} from "@/constants/Financement";
import {SaisieRepository} from "@/repository/saisie";


export default {
  name: 'SaisieForm',
  props: {
      dossier_id: Number,
      dossier: Object,
      type: String,
  },
  data() {
    return {
      saisieSource: null,
      dialog: false,
      creating: false,
    }
  },
  computed: {
    sources() {
      let sources = this.type === 'Encaissement' ? TYPES_ENCAISSEMENT : TYPES_DECAISSEMENT.concat(TYPES_DECAISSEMENT_HORS_PLAN);
      return sources.filter(source => this.usedSaisies.indexOf(source) === -1);
    },
    isEncaissement() {
      return this.type === 'Encaissement';
    },
    color() {
      return this.isEncaissement ? "primary": "secondary";
    },
    usedSaisies() {
      return this.dossier.saisies.map(saisie => saisie.source);
    },
    textColor() {
      return this.isEncaissement ? "primary--text" : "secondary--text";
    },
    text() {
      var action = "Créer";
      var obj = this.isEncaissement ? " un encaissement" : " un décaissement";
      return action + obj;
    }
  },
  methods: {
    async createSaisie() {
      this.creating = true;
      try {
        let repository = new SaisieRepository();
        let response = await repository.post({
          dossier: this.dossier_id,
          type: this.type,
          source: this.saisieSource
        });
        if (response) {
          this.$store.dispatch("annonce/annonceSuccess", "Saisie créé");
          this.$emit("reload");
        }
      } finally {
        this.dialog = false;
        this.creating = false;
      }

    }
  }
}
</script>